import client from 'client'
import slugify from 'utils/slugify'

export const fetchSuburbs = city =>
  client().get(`/cities/${slugify(city)}/suburbs`)

export const fetchSuburb = (city, suburb) => {
  return client().get(`/cities/${slugify(city)}/suburbs/${slugify(suburb)}`)
}
